import React from "react";
import { BiBot, BiPhoneIncoming, BiPhoneOff, BiTimer } from "react-icons/bi";
import { MdOutlinePhonePaused } from "react-icons/md";

const RealtimeQueuesGeneral = ({ stats, loading = true }) => {
  const renderValueOrSkeleton = (value, additionalClasses = "") =>
    loading ? (
      <div
        className={`w-24 h-6 mt-1 bg-gray-300 rounded animate-pulse ${additionalClasses}`}
      ></div>
    ) : (
      value
    );

  return (
    <div className="flex items-center gap-4 p-2 h-full">
      {/* Panel Izquierdo: Global Stats */}
      <div className="flex-1 bg-white rounded-lg shadow-md p-4 h-full flex flex-col justify-center dark:bg-primary-dark">
        <div className="flex justify-around items-center">
          <div className="flex flex-col items-center">
            <p className="text-sm font-medium text-gray-700 dark:text-white">
              Attended{" "}
              <span className="font-light text-s">
                ({stats?.attendedCalls || "0"} calls){" "}
              </span>
            </p>
            <span className="text-5xl font-semibold text-green-600 flex gap-1 items-center">
              <BiPhoneIncoming className="text-2xl relative top-2" />{" "}
              {renderValueOrSkeleton(`${stats?.attendedPercentage || "0"}%`)}
            </span>
          </div>
          <div className="flex flex-col items-center">
            <p className="text-sm font-medium text-gray-700 dark:text-white">
              Non Attended{" "}
              <span className="font-light text-s">
                ({stats?.abandonedCalls || "0"} calls)
              </span>
            </p>
            <span className="text-5xl font-semibold text-red-500 flex gap-1 items-center">
              <BiPhoneOff className="text-2xl relative top-2" />{" "}
              {renderValueOrSkeleton(`${stats?.abandonedPercentage || "0"}%`)}
            </span>
          </div>
        </div>
      </div>

      {/* Panel Central: Calls in Queue */}
      <div className="flex-[0.5] bg-white rounded-lg shadow-md p-4 h-full flex flex-col items-center justify-center dark:bg-primary-dark">
        <div className="text-center">
          <p className="text-xs text-gray-500 dark:text-white">In queue</p>
          <span
            className={`text-5xl font-semibold ${
              stats?.callsInQueue > 0 ? "text-purple-600" : "text-gray-400"
            }`}
          >
            {renderValueOrSkeleton(stats?.callsInQueue, "text-center")}
          </span>
        </div>
      </div>

      {/* Panel Derecho: Performance Stats */}
      <div className="flex-1 bg-white rounded-lg shadow-md p-4 h-full flex flex-col justify-center items-center dark:bg-primary-dark">
        <div className="flex justify-around items-center gap-16">
          <div className="flex flex-col items-center gap-1">
            <p className="text-xs text-gray-500 dark:text-white">
              AVG Talk Time
            </p>
            <span className="text-5xl font-semibold text-gray-600 flex items-center gap-1 dark:text-white">
              <BiTimer className="text-2xl relative top-2" />{" "}
              {renderValueOrSkeleton(stats?.avgTalkTime)}
            </span>
          </div>
          <div className="flex flex-col items-center gap-1">
            <p className="text-xs text-gray-500 dark:text-white">
              AVG Wait Time
            </p>
            <span className="text-5xl font-semibold text-gray-600 flex items-center gap-1 dark:text-white">
              <MdOutlinePhonePaused className="text-2xl relative top-2" />{" "}
              {renderValueOrSkeleton(stats?.avgWaitTime)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RealtimeQueuesGeneral;
